function Delimiter(price) {
  if (!price) {
    return 0;
  } else {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
}

export{Delimiter};
